import classnames from 'classnames';
import React from 'react';

import { RichTextEditorMenu } from 'src/Components/Shared/RichTextEditor/RichTextEditorMenu';

import styles from './RichTextEditorToolbar.module.scss';
import { Props } from './RichTextEditorToolbar.types';

const RichTextEditorToolbar = React.forwardRef<HTMLDivElement, Props>(
  ({ className, children, ...props }, ref) => (
    <RichTextEditorMenu {...props} ref={ref} className={classnames(styles.toolbar, className)}>
      {children}
    </RichTextEditorMenu>
  )
);
export default RichTextEditorToolbar;
